export default [
  {
    path: '/admin/employee-card-activators',
    name: 'employee-card-activators',
    meta: { requiresAuth: true },
    component: () => import('@/pages/human-resource/card-activator')
  }
]
